import React from 'react';
import { ChevronDown } from 'lucide-react';

// 表单字段组件
const FormField = ({ label, type = 'text', value, onChange, onBlur, placeholder, required = false, maxLength, disabled = false, error }) => {
  // 确保value始终有定义的值，避免受控/非受控组件警告
  const safeValue = value || '';

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {type === 'textarea' ? (
        <textarea
          value={safeValue}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          className={`w-full px-4 py-3 border rounded-lg transition-all duration-200 resize-none ${
            disabled
              ? 'border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
              : error
              ? 'border-red-500 bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent shadow-sm hover:shadow-md'
              : 'border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm hover:shadow-md'
          }`}
          rows="4"
        />
      ) : type === 'select' ? (
        <div className="relative">
          <select
            value={safeValue}
            onChange={onChange}
            onBlur={onBlur}
            className={`w-full h-12 px-4 py-3 pr-10 border rounded-lg focus:outline-none transition-all duration-200 appearance-none cursor-pointer ${
              error
                ? 'border-red-500 bg-red-50 focus:ring-2 focus:ring-red-500 focus:border-transparent shadow-sm hover:shadow-md'
                : 'border-gray-300 bg-gradient-to-r from-white to-gray-50 focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm hover:shadow-md'
            }`}
          >
            <option value="" className="text-gray-500">请选择...</option>
            {placeholder && placeholder.split(',').map(option => (
              <option key={option} value={option} className="text-gray-800 py-2">
                {option}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <ChevronDown className="h-5 w-5 text-gray-400" />
          </div>
        </div>
      ) : (
        <input
          type={type}
          value={safeValue}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          className={`w-full h-12 px-4 py-3 border rounded-lg transition-all duration-200 ${
            disabled
              ? 'border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
              : error
              ? 'border-red-500 bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent shadow-sm hover:shadow-md'
              : 'border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm hover:shadow-md'
          }`}
        />
      )}

      {/* 错误信息显示 */}
      {error && (
        <p className="mt-2 text-sm text-red-600 flex items-start animate-shake">
          <span className="mr-1 text-base">⚠️</span>
          <span className="flex-1">{error}</span>
        </p>
      )}
    </div>
  );
};

export default FormField;